import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Form } from 'react-bootstrap';
import './AdminProfessionalInfo.css';

function AdminCNCProgrammerFields({ formData, setFormData }) {
    const updateField = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

    const toggleArrayField = (field, item) => {
        const currentArray = Array.isArray(formData[field]) ? formData[field] : [];
        if (currentArray.includes(item)) {
            updateField(field, currentArray.filter(i => i !== item));
        } else {
            updateField(field, [...currentArray, item]);
        }
    };

    // Data arrays (same as ProfessionalInfo.js)
    const industryOptions = ["Manufacturing", "Oil & Gas", "Aerospace", "Automotive"];
    const cncControlsList = ["FANUC", "Siemens", "Heidenhain", "Mitsubishi", "Mazak", "Haas", "OKUMA", "Other"];
    const cncMachinesList = ["CNC Turning (Lathe)", "CNC Milling", "VMC", "HMC", "5-Axis", "Swiss Type", "Other"];
    const programmingTypes = ["Manual G-Code", "Macro Programming", "Conversational"];
    const cadCamList = ["Mastercam", "SolidCAM", "UG NX", "Fusion 360", "PowerMill", "SolidWorks", "Other"];
    const yesNoOptions = ["Yes", "No"];
    const gdtKnowledgeOptions = ["Basic", "Good", "Expert"];
    const jobSkillsList = [
        "Cycle Time Optimization", "Process Planning", "Tool Selection & Tool Life Control",
        "Fixture / Jigs Knowledge", "Quality inspection (Vernier/Micrometer/Bore Gauge)",
        "CMM Knowledge", "ISO Standards / Tolerances"
    ];

    // Dropdown states
    const [controlsOpen, setControlsOpen] = useState(false);
    const [controlsSearch, setControlsSearch] = useState('');
    const [machinesOpen, setMachinesOpen] = useState(false);
    const [machinesSearch, setMachinesSearch] = useState('');
    const [cadCamOpen, setCadCamOpen] = useState(false);
    const [cadCamSearch, setCadCamSearch] = useState('');
    const [skillsOpen, setSkillsOpen] = useState(false);
    const [skillsSearch, setSkillsSearch] = useState('');

    const cnc_controls = Array.isArray(formData.cnc_controls) ? formData.cnc_controls : [];
    const cnc_machines = Array.isArray(formData.cnc_machines) ? formData.cnc_machines : [];
    const cad_cam_knowledge = Array.isArray(formData.cad_cam_knowledge) ? formData.cad_cam_knowledge : [];
    const job_skills_checklist = Array.isArray(formData.job_skills_checklist) ? formData.job_skills_checklist : [];

    const MultiSelectDropdown = ({ id, title, options, selectedValues, field, isOpen, setIsOpen, search, setSearch }) => {
        const filtered = options.filter(o => o.toLowerCase().includes(search.toLowerCase()));
        return (
            <Dropdown show={isOpen} onToggle={(open) => setIsOpen(open)} className="mb-3">
                <Dropdown.Toggle variant="light" className="language-select w-100 d-flex justify-content-between align-items-center" id={id}>
                    <span style={{ color: selectedValues.length > 0 ? '#212529' : '#6c757d' }}>
                        {selectedValues.length > 0 ? `${title} (${selectedValues.length} selected)` : title}
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                    <div className="px-2 py-1">
                        <Form.Control type="text" placeholder={`Search...`} value={search} onChange={(e) => setSearch(e.target.value)} onClick={(e) => e.stopPropagation()} className="mb-2" autoFocus />
                    </div>
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                        {filtered.map((opt) => (
                            <Dropdown.Item key={opt} active={selectedValues.includes(opt)} onClick={() => toggleArrayField(field, opt)}>{opt}</Dropdown.Item>
                        ))}
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    return (
        <>
            {/* Industry Experience */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Industry Experience *</h4>
                <Row className="g-3 mb-3">
                    {industryOptions.map((opt, idx) => (
                        <Col xs={6} md={3} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${formData.industry_experience === opt ? 'selected-button' : ''}`} onClick={() => updateField('industry_experience', opt)}>{opt}</Button>
                        </Col>
                    ))}
                </Row>
                <div className="mt-3">
                    <Form.Control
                        type="text"
                        placeholder="Other Industry Experience (Type here)"
                        className="professional-input"
                        value={!industryOptions.includes(formData.industry_experience) && formData.industry_experience ? formData.industry_experience : ''}
                        onChange={(e) => updateField('industry_experience', e.target.value)}
                    />
                </div>
            </div>

            {/* Machine & Control Knowledge */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Machine & Control Knowledge</h4>
                <MultiSelectDropdown id="dd-cnc-controls" title="Select CNC Controls" options={cncControlsList} selectedValues={cnc_controls} field="cnc_controls" isOpen={controlsOpen} setIsOpen={setControlsOpen} search={controlsSearch} setSearch={setControlsSearch} />
                {cnc_controls.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {cnc_controls.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('cnc_controls', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
                <MultiSelectDropdown id="dd-cnc-machines" title="Select CNC Machines" options={cncMachinesList} selectedValues={cnc_machines} field="cnc_machines" isOpen={machinesOpen} setIsOpen={setMachinesOpen} search={machinesSearch} setSearch={setMachinesSearch} />
                {cnc_machines.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {cnc_machines.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('cnc_machines', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Programming & Software Skills */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Programming & Software Skills</h4>

                {/* Programming Type */}
                <h5 className="mb-2 mt-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Programming Type</h5>
                <Row className="g-3 mb-3">
                    {programmingTypes.map((opt, idx) => (
                        <Col xs={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${formData.programming_type === opt ? 'selected-button' : ''}`} onClick={() => updateField('programming_type', opt)}>{opt}</Button>
                        </Col>
                    ))}
                </Row>

                {/* CAD/CAM Knowledge */}
                <MultiSelectDropdown id="dd-cad-cam" title="Select CAD/CAM Software" options={cadCamList} selectedValues={cad_cam_knowledge} field="cad_cam_knowledge" isOpen={cadCamOpen} setIsOpen={setCadCamOpen} search={cadCamSearch} setSearch={setCadCamSearch} />
                {cad_cam_knowledge.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {cad_cam_knowledge.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('cad_cam_knowledge', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}

                {/* Can you read engineering drawings? */}
                <h5 className="mb-3 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Can you read engineering drawings?</h5>
                <Row className="g-3 mb-3">
                    {yesNoOptions.map((opt, idx) => (
                        <Col xs={6} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${formData.read_engineering_drawings === opt ? 'selected-button' : ''}`} onClick={() => updateField('read_engineering_drawings', opt)}>{opt}</Button>
                        </Col>
                    ))}
                </Row>

                {/* GD&T Knowledge */}
                <h5 className="mb-3 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>GD&T Knowledge</h5>
                <Row className="g-3 mb-3">
                    {gdtKnowledgeOptions.map((opt, idx) => (
                        <Col xs={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${formData.gdt_knowledge === opt ? 'selected-button' : ''}`} onClick={() => updateField('gdt_knowledge', opt)}>{opt}</Button>
                        </Col>
                    ))}
                </Row>

                {/* Tool Setting / Offsets */}
                <h5 className="mb-3 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Tool Setting / Offsets</h5>
                <Row className="g-3 mb-3">
                    {yesNoOptions.map((opt, idx) => (
                        <Col xs={6} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${formData.tool_setting_offsets === opt ? 'selected-button' : ''}`} onClick={() => updateField('tool_setting_offsets', opt)}>{opt}</Button>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Job Skills Checklist */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Job Skills Checklist</h4>
                <MultiSelectDropdown id="dd-job-skills" title="Select Skills" options={jobSkillsList} selectedValues={job_skills_checklist} field="job_skills_checklist" isOpen={skillsOpen} setIsOpen={setSkillsOpen} search={skillsSearch} setSearch={setSkillsSearch} />
                {job_skills_checklist.length > 0 && (
                    <div className="mt-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                        <h6 className="mb-3">Selected Skills:</h6>
                        {job_skills_checklist.map((skill, idx) => (
                            <div key={idx} className="d-flex align-items-center mb-2">
                                <i className="bi bi-check-circle-fill text-success me-2"></i>
                                <span>{skill}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}

export default AdminCNCProgrammerFields;
